import mock from "@/@fake-db/mock";

const GetServerTimezone = { timezone_offset: 0 };

mock.onGet("/GetServerTimezone/data").reply(() => [200, GetServerTimezone]);
